export type SelectableTable = {
  id: string
  tableNo: string
  name?: string
  sortOrder?: number
  enabled?: number
}

export function tableDisplayName(table: SelectableTable) {
  const name = table.name?.trim()
  if (name) return name
  const tableNo = table.tableNo.trim()
  return tableNo.includes('桌') ? tableNo : `${tableNo}号桌`
}

export function selectableTables<T extends SelectableTable>(tables?: T[]) {
  return [...(tables || [])]
    .filter((table) => table.enabled !== 0)
    .sort((left, right) => (left.sortOrder ?? 0) - (right.sortOrder ?? 0))
}
